var exports = {
  "N0": "x61f99309--2de38a--card-container",
  "Yu": "x61f99309--2de38a--text-block",
  "mx": "x61f99309--2de38a--image-block",
  "YE": "x61f99309--2de38a--image-content",
};

module.exports = exports;
